import mail from '../../assets/images/userProfile/mail.png'
import trophy from '../../assets/images/userProfile/trophy.png'

export const userProfile = {
    mail,
    trophy,
}
